var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStHereRight16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7489 8.58831C11.0837 8.26292 11.0837 7.73448 10.7489 7.40909L6.46418 3.24405C6.12944 2.91865 5.58581 2.91865 5.25106 3.24405C4.91631 3.56944 4.91631 4.09788 5.25106 4.42327L8.9306 8L5.25374 11.5767C4.91899 11.9021 4.91899 12.4306 5.25374 12.756C5.58848 13.0813 6.13211 13.0813 6.46686 12.756L10.7516 8.59092L10.7489 8.58831Z",
    fill: "#0592FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStHereRight16);
export default __webpack_public_path__ + "static/media/StHere_right_16.2da03909123858362f0e8b9e509b6b75.svg";
export { ForwardRef as ReactComponent };